/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIShippingStatusEnum } from './APIShippingStatusEnum';
import {
    APIShippingStatusEnumFromJSON,
    APIShippingStatusEnumFromJSONTyped,
    APIShippingStatusEnumToJSON,
} from './APIShippingStatusEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedShippingRequest
 */
export interface APIPatchedShippingRequest {
    /**
     * 
     * @type {number}
     * @memberof APIPatchedShippingRequest
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof APIPatchedShippingRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIPatchedShippingRequest
     */
    wishDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedShippingRequest
     */
    address?: string;
    /**
     * 
     * @type {APIShippingStatusEnum}
     * @memberof APIPatchedShippingRequest
     */
    shippingStatus?: APIShippingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedShippingRequest
     */
    trackingNumber?: string;
}



/**
 * Check if a given object implements the APIPatchedShippingRequest interface.
 */
export function instanceOfAPIPatchedShippingRequest(value: object): value is APIPatchedShippingRequest {
    return true;
}

export function APIPatchedShippingRequestFromJSON(json: any): APIPatchedShippingRequest {
    return APIPatchedShippingRequestFromJSONTyped(json, false);
}

export function APIPatchedShippingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedShippingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'dueDate': json['due_date'] == null ? undefined : (new Date(json['due_date'])),
        'wishDate': json['wish_date'] == null ? undefined : (new Date(json['wish_date'])),
        'address': json['address'] == null ? undefined : json['address'],
        'shippingStatus': json['shipping_status'] == null ? undefined : APIShippingStatusEnumFromJSON(json['shipping_status']),
        'trackingNumber': json['tracking_number'] == null ? undefined : json['tracking_number'],
    };
}

export function APIPatchedShippingRequestToJSON(value?: APIPatchedShippingRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'due_date': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'wish_date': value['wishDate'] == null ? undefined : ((value['wishDate']).toISOString()),
        'address': value['address'],
        'shipping_status': APIShippingStatusEnumToJSON(value['shippingStatus']),
        'tracking_number': value['trackingNumber'],
    };
}

